import Glide from "@glidejs/glide";

if (document.getElementById("js-glide-timeline")) {
  const config = {
    rewind: false,
    perView: 5,
    focusAt: 0,
    breakpoints: {
      800: {
        perView: 2
      },
      480: {
        perView: 1
      }
    }
  };
  let glide = new Glide('.glide-timeline', config)

  glide.mount()
}
